import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { GlobalSecondaryHeaderComponent } from "./global-secondary-header/global-secondary-header.component";
import { SubheaderBreadcrumbComponent } from "./subheader-breadcrumb/subheader-breadcrumb.component";
import { SubheaderAlertsComponent } from "./subheader-alerts/subheader-alerts.component";
import { IconsModule } from "@va/core-library/icons";
import { ButtonModule } from "@va/core-library/button";
import { SubheaderRequestBrokerComponent } from "./subheader-request-broker/subheader-request-broker.component";

import { SubheaderCompanyNotesComponent } from "./subheader-company-notes/subheader-company-notes.component";
import { SharedModule } from "../shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RequestModalComponent } from "./request-modal/request-modal.component";
import { RequestModalComponent as RequestModalComponentv2 } from "./request-modal-v2/request-modal.component";
import { WatchlistModule } from "../watchlist/watchlist.module";
import { ManageWatchlistModalComponent } from "../watchlist-page/manage-watchlist-modal/manage-watchlist-modal.component";
import { SubheaderFormulabarComponent } from "./subheader-formulabar/subheader-formulabar.component";
import { ShortcutsModalComponent } from "./shortcuts-modal/shortcuts-modal.component";
import { LabsPageModule } from "../labs-page/labs-page.module";
import { IndustryAnalysisPageModule } from "../sectors-and-industries-page/industry-analysis-page.module";
import { IndustrySubheaderComponent } from "./industry-subheader/industry-subheader.component";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzBreadCrumbModule } from "ng-zorro-antd/breadcrumb";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzTreeModule } from "ng-zorro-antd/tree";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { CorporateRequestModalComponent } from "./corporate-request-modal/corporate-request-modal.component";
import { BiopharmaSearchComponent } from "./biopharma-search/biopharma-search.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { FormulaBarModule } from "@va/core-library/formula-bar";
import { ComparativeAnalysisSubheaderComponent } from "./comparative-analysis-subheader/comparative-analysis-subheader.component";

@NgModule({
  declarations: [
    GlobalSecondaryHeaderComponent,
    SubheaderBreadcrumbComponent,
    SubheaderAlertsComponent,
    SubheaderRequestBrokerComponent,
    SubheaderCompanyNotesComponent,
    RequestModalComponent,
    RequestModalComponentv2,
    ManageWatchlistModalComponent,
    SubheaderFormulabarComponent,
    ShortcutsModalComponent,
    IndustrySubheaderComponent,
    CorporateRequestModalComponent,
    BiopharmaSearchComponent,
    ComparativeAnalysisSubheaderComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    IconsModule,
    ButtonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    WatchlistModule,
    ButtonModule,
    IndustryAnalysisPageModule,
    LabsPageModule,
    NzDropDownModule,
    NzPopoverModule,
    NzLayoutModule,
    NzModalModule,
    NzSelectModule,
    NzGridModule,
    NzInputModule,
    NzCheckboxModule,
    NzSkeletonModule,
    NzBreadCrumbModule,
    NzSpinModule,
    NzTreeModule,
    NzToolTipModule,
    NzTableModule,
    NzMenuModule,
    FormulaBarModule,
  ],
  exports: [
    GlobalSecondaryHeaderComponent,
    RequestModalComponent,
    RequestModalComponentv2,
    SubheaderFormulabarComponent,
    CorporateRequestModalComponent,
  ],
})
export class GlobalSubheaderModule {}
